export default "__VITE_ASSET__BOSbqCA2__"